import React from 'react'

export const FlagInput = ({className, tabIndex, changeHandler, flag = true, values = ['Да', 'Нет']}) => {
    return (
    <div onClick={() => changeHandler(!flag)} tabIndex={tabIndex} className={className} data-value={flag} style={{cursor: 'pointer'}}>
        {flag ? values[0] : [values[1]]}
    </div>)
}
